import errorMessages from '@common/constants/errorMessages';
import { isEmpty, validEmailAddress } from '@common/paymentsUtils/inputValidator';

function isFirstNameValid(firstName) {
  if (isEmpty(firstName)) {
    return errorMessages.TENANT_FIRST_NAME_EMPTY;
  }
  return errorMessages.CLEAR_ERROR;
}

function isLastNameValid(lastName) {
  if (isEmpty(lastName)) {
    return errorMessages.TENANT_LAST_NAME_EMPTY;
  }
  return errorMessages.CLEAR_ERROR;
}

const isEmailAddressValid = ({ tenantEmail, currentTenantEmail, landlordEmail }) => {
  if (isEmpty(tenantEmail)) {
    return errorMessages.TENANT_EMAIL_ADDRESS_EMPTY;
  } else if (!validEmailAddress(tenantEmail)) {
    return errorMessages.INVALID_EMAIL_ADDRESS;
  } else if (tenantEmail === currentTenantEmail) {
    return errorMessages.CANNOT_INVITE_EXISTING_RENTER;
  } else if (tenantEmail === landlordEmail) {
    return errorMessages.UNIQUE_EMAIL_ADDRESS;
  }
  return errorMessages.CLEAR_ERROR;
};

export const validateAllInputs = (ctx) => {
  const { tenantFirstName, tenantLastName, tenantEmail } = ctx.state;
  const { currentTenantEmail, landlordEmail, trackValidationError } = ctx.props;
  const errors: any = [];

  const tenantFirstNameError = isFirstNameValid(tenantFirstName.value);
  const tenantLastNameError = isLastNameValid(tenantLastName.value);
  const tenantEmailError = isEmailAddressValid({
    tenantEmail: tenantEmail.value,
    currentTenantEmail,
    landlordEmail,
  });

  if (tenantFirstNameError) {
    errors.push({ tenantFirstName: tenantFirstNameError });
  }

  if (tenantLastNameError) {
    errors.push({ tenantLastName: tenantLastNameError });
  }

  if (tenantEmailError) {
    errors.push({ tenantEmail: tenantEmailError });
  }
  ctx.setState({
    tenantFirstName: { ...tenantFirstName, error: tenantFirstNameError },
    tenantLastName: { ...tenantLastName, error: tenantLastNameError },
    tenantEmail: { ...tenantEmail, error: tenantEmailError },
  });

  if (errors.length > 0) {
    if (trackValidationError) {
      trackValidationError({ errors });
    }
    return false;
  }

  return true;
};
